(function() {
  "use strict";

  angular.module("sempraWebapp").service("modelUtils", modelUtilsService);

  /** @ngInject */
  function modelUtilsService(ReadingTypeEnum, ActuatorTypeEnum) {
    this.getPoint = function(pointJson, pointReference) {
      var foundPointJson = findPoint(pointJson, pointReference);
      return foundPointJson ? foundPointJson : null;
    };

    this.getFeedCurrentValue = function(pointJson, feedReference) {
      var foundFeedJson = findFeed(pointJson, feedReference);
      return foundFeedJson
        ? parseFeedCurrentValue(
            foundFeedJson.currentValue,
            foundFeedJson.readingType
          )
        : null;
    };

    this.getFeed = function(pointJson, feedReference) {
      var foundFeedJson = findFeed(pointJson, feedReference);
      return foundFeedJson ? foundFeedJson : null;
    };

    this.parseFeedCurrentValue = function(currentValue, readingType) {
      return parseFeedCurrentValue(currentValue, readingType);
    };

    this.getActuatorCurrentValue = function(pointJson, actuatorReference) {
      var foundActuatorJson = findActuator(pointJson, actuatorReference);
      return foundActuatorJson
        ? parseActuatorCurrentValue(
            foundActuatorJson.value,
            foundActuatorJson.actuatorType
          )
        : null;
    };

    this.getActuator = function(pointJson, actuatorReference) {
      var foundActuatorJson = findActuator(pointJson, actuatorReference);
      return foundActuatorJson ? foundActuatorJson : null;
    };

    this.parseActuatorCurrentValue = function(currentValue, actuatorType) {
      return parseActuatorCurrentValue(currentValue, actuatorType);
    };

    this.parseActuatorCurrentHourValue = function(currentValue) {
      return parseInt(currentValue.substring(0, 2));
    };

    this.parseActuatorCurrentMinuteValue = function(currentValue) {
      return parseInt(currentValue.substring(2, 4));
    };

    this.parseActuatorRangeValue = function(currentValue, actuatorType) {
      return parseActuatorRangeValue(currentValue, actuatorType);
    };

    this.extendObject = function() {
      angular.extend.apply(this, arguments);
    };

    this.copyObject = function() {
      angular.copy.apply(this, arguments);
    };

    this.extendArray = function(
      arrayDest,
      arraySrc,
      constructor,
      destIdentifierKey,
      srcIdentifierKey
    ) {
      //remove no longer available in source
      arrayDest.forEach(function(dstItem, dstItemIndex) {
        var foundSrcItem = arraySrc.find(function(srcItem) {
          return dstItem[destIdentifierKey] === srcItem[srcIdentifierKey];
        });

        if (typeof foundSrcItem === "undefined") {
          arrayDest.splice(dstItemIndex, 1);
        }
      });

      //add-update existing in source
      if (arraySrc !== null) {
        arraySrc.forEach(function(srcItem) {
          var foundDstItem = arrayDest.find(function(dstItem) {
            return dstItem[destIdentifierKey] === srcItem[srcIdentifierKey];
          });

          if (foundDstItem) {
            if (isFunction(foundDstItem.refresh)) {
              foundDstItem.refresh(srcItem);
            } else {
              foundDstItem = srcItem;
            }
          } else {
            if (isFunction(constructor)) {
              arrayDest.push(new constructor(srcItem));
            } else {
              arrayDest.push(srcItem);
            }
          }
        });
      }
    };

    function findPoint(pointJson, pointReference) {
      return pointJson.points.find(function(point) {
        return point.reference === pointReference;
      });
    }

    function findFeed(pointJson, feedReference) {
      return pointJson.feeds.find(function(feed) {
        return feed.reference === feedReference;
      });
    }

    function findActuator(pointJson, actuatorReference) {
      return pointJson.actuators.find(function(actuator) {
        return actuator.reference === actuatorReference;
      });
    }

    // function findSubSystemActuator(pointJson, actuatorReference){
    //   return pointJson.points.find(function (actuator) {
    //     return actuator.reference === actuatorReference;
    //   });
    // }

    function parseFeedCurrentValue(currentValue, readingType) {
      return ReadingTypeEnum.properties[readingType].parse(currentValue);
    }

    function parseActuatorCurrentValue(currentValue, actuatorType) {
      return ActuatorTypeEnum.properties[actuatorType].parseValue(currentValue);
    }

    function parseActuatorRangeValue(rangeValue, actuatorType) {
      return ActuatorTypeEnum.properties[actuatorType].parseRange(rangeValue);
    }

    function isFunction(obj) {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    }
  }
})();
